import { Component, OnInit, Input, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'ark-notifybox',
  templateUrl: './notifybox.component.html',
  styleUrls: ['./notifybox.component.scss']
})
export class NotifyboxComponent implements OnInit {

  message = '';
  label = 'Close';

  constructor(
    public dialogRef: MatDialogRef<NotifyboxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.message = this.data.message;
    if (this.data.label) {
      this.label = this.data.label;
    }
  }

  close() {
    if (this.data.reload == false) {
      if (this.data.isclose) {
        this.dialogRef.close(true);
        return;
      }
    } else {
      window.location.reload();
    }
    this.dialogRef.close();
  }

}
